import { ToothFdiValues } from '../constants';
import { DentalNotation, TreatmentType } from '../enums';
export function getToothTitle(tooth: number | string, dentalNotation: number) {
  if (typeof tooth === 'number') {
    return dentalNotation === DentalNotation.Fdi && tooth != 0 ? ToothFdiValues[tooth - 1] : tooth;
  }

  return dentalNotation === DentalNotation.Fdi
    ? tooth
        .split(', ')
        .map(x => ToothFdiValues[parseInt(x) - 1])
        .join(', ')
    : tooth;
}

export function getTreatmentSubTypeLabel(treatmentTypeId: TreatmentType) {
  let label: string;
  switch (treatmentTypeId) {
    case TreatmentType.NightGuard:
      label = 'general.nightGuardType';
      break;
    case TreatmentType.SmileDesign:
      label = 'general.smileDesignType';
      break;
    case TreatmentType.SurgicalGuide:
      label = 'general.designTurnaroundTime';
      break;
    case TreatmentType.CrownAndBridge:
      label = 'general.crownType';
      break;

    case TreatmentType.RemovableDentures:
      label = 'general.removableDenturesType';
      break;

    case TreatmentType.Veneers:
    case TreatmentType.NeerCrystal:
      label = 'general.designStyle';
      break;

    default:
      label = 'general.treatmentSubType';
      break;
  }
  return label;
}
